module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"menu_panel_language":"Sprache: Englisch"},"en":{"menu_panel_language":"Language: German"}}')
  delete Component.options._Ctor
}
